var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import Storage from 'helpers/Storage';
import { View, Text } from 'elements';
import { padding } from '../../../Theme';
import { toMoney } from '../../../helpers/Format';
import { T } from '../../../helpers/i18n';
import history from '../../../helpers/History';
import { inject } from 'mobx-react';
let CashDeskList = class CashDeskList extends Component {
    constructor(props) {
        super(props);
        this.handleOnClick = (ticket) => {
            // history.push('/tickets/' + ticket.numero, ticket)
            history.push('/cashDeskList/' + ticket.numero, ticket);
        };
        // console.log('CashDeskList - constructor()')
        const user = Storage.getJSON('user');
        if (user) {
            this.caja = Storage.getJSON(user.id);
        }
    }
    componentDidMount() {
        const hasParent = (history.location.pathname.match(/\//g) || []).length >= 2;
        // console.log('StretchesList - componentDidMount - hasParent', hasParent)
        this.props.store.UI.changeHasParent(hasParent);
    }
    render() {
        // console.log('CashDeskList - render()')
        if (!this.caja || this.caja.tickets.length === 0) {
            return (React.createElement("div", null, T('noDatos')));
        }
        const { tickets } = this.caja;
        return (React.createElement("div", null, tickets.map((item, index) => React.createElement(ItemTicket, { key: item.numero, last: index === tickets.length - 1, ticket: item, onClick: this.handleOnClick }))));
    }
};
CashDeskList = __decorate([
    inject('store')
], CashDeskList);
export default CashDeskList;
const ItemTicket = ({ ticket, last, onClick }) => {
    const cancelado = !!ticket.daterefund;
    const noenviado = !ticket.id;
    return (React.createElement(View, { flex: true, onClick: () => onClick(ticket), style: {
            justifyContent: 'center',
        } },
        React.createElement(View, { flex: true, row: true, style: Object.assign({ justifyContent: 'space-between' }, padding()) },
            React.createElement(Text, null, ticket.numero),
            React.createElement(Text, { style: { color: noenviado ? 'red' : undefined }, date: true }, ticket.datecheck)),
        React.createElement(View, { flex: true, row: true, style: Object.assign(Object.assign({}, padding()), { borderBottom: !last ? '2px dotted black' : undefined }) },
            React.createElement(Text, { style: { color: cancelado ? 'orange' : undefined, textDecorationLine: cancelado ? 'line-through' : 'none' } }, ticket.daterefund ? `${toMoney(ticket.total)}` : toMoney(ticket.total)),
            cancelado && React.createElement(Text, { style: { color: 'orange', paddingLeft: 10 } }, `${T('canceled')}`))));
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/CashDeskList.tsx
// module id = 533
// module chunks = 0